'use client';
import React from 'react';
import { MOCK_RESULTS } from './MockExamScreen';
import QuestionTypeAccuracyChart from './QuestionTypeAccuracyChart';

interface Props {
  results: typeof MOCK_RESULTS;
}

export default function ReportQuestionAnalysis({ results }: Props) {
  return (
    <div className="space-y-6 animate-slide-up">
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
        <QuestionTypeAccuracyChart data={results.byType} />

        {/* Table */}
        <div className="card-base p-5">
          <h2 className="section-header mb-4">Accuracy Table — All 9 Question Types</h2>
          <div className="overflow-x-auto scrollbar-thin">
            <table className="w-full text-sm min-w-[400px]">
              <thead>
                <tr className="border-b border-border">
                  {['Question Type', 'Score', 'Accuracy', 'Avg Time', 'Status'].map((h) => (
                    <th key={`qat-${h}`} className="text-left text-xs font-medium text-muted-foreground pb-2.5 pr-3 uppercase tracking-wide">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-border">
                {results.byType.map((row) => {
                  const pct = Math.round((row.correct / row.total) * 100);
                  const status = pct >= 80 ? 'On track' : pct >= 60 ? 'At risk' : 'Critical';
                  const statusColor = pct >= 80 ? 'text-accent bg-success-bg' : pct >= 60 ? 'text-warning bg-warning-bg' : 'text-danger bg-danger-bg';
                  const timeColor = row.time > 90 ? 'text-warning font-semibold' : 'text-foreground';
                  return (
                    <tr key={row.id} className="hover:bg-muted/40 transition-colors">
                      <td className="py-2.5 pr-3 text-xs font-medium text-foreground">{row.type}</td>
                      <td className="py-2.5 pr-3 text-xs tabular-nums text-foreground font-semibold">{row.correct}/{row.total}</td>
                      <td className="py-2.5 pr-3">
                        <div className="flex items-center gap-2">
                          <div className="w-12 h-1.5 bg-muted rounded-full overflow-hidden">
                            <div
                              className={`h-full rounded-full ${pct >= 80 ? 'bg-accent' : pct >= 60 ? 'bg-warning' : 'bg-danger'}`}
                              style={{ width: `${pct}%` }}
                            />
                          </div>
                          <span className={`text-xs font-semibold tabular-nums ${pct >= 80 ? 'text-accent' : pct >= 60 ? 'text-warning' : 'text-danger'}`}>{pct}%</span>
                        </div>
                      </td>
                      <td className={`py-2.5 pr-3 text-xs tabular-nums ${timeColor}`}>{row.time}s</td>
                      <td className="py-2.5">
                        <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-semibold ${statusColor}`}>{status}</span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}